module.exports = __webpack_public_path__ + "img/Anu Yammanuru1.9c514097.jpg";